<template>
	<!-- 第五区代码 -->
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny' cleartable> 
						<!--  -->
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.authStatus" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="通 过" :value="1">通 过</el-option>
							<el-option key="2" label="驳 回" :value="2">驳 回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="下架" :value="0">下架</el-option>
							<el-option key="1" label="上架" :value="1">上架</el-option>
						</el-select>
					</el-form-item>

					

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dialogVisibleFun('')" v-if="stoId != 0">新增商品
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="用户ID">
							<span>{{ props.row.userId?props.row.userId:'无' }}</span>
						</el-form-item>
						<el-form-item label="用户名">
							<span>{{ props.row.username?props.row.username:'无' }}</span>
						</el-form-item>
					
						<el-form-item label="店铺名称">
							<span>{{ props.row.storeName }}</span>
					
						</el-form-item>
						<el-form-item label="商品ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="商品名称">
							<span>{{ props.row.goodsName }}</span>
						</el-form-item>
						<el-form-item label="商品编号">
							<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
						</el-form-item>
						<el-form-item label="分类名称">
							<span>{{ props.row.className }}</span>
						</el-form-item>
						<el-form-item label="市场价">
							<span>{{ props.row.marketPrice }}</span>
						</el-form-item>
						
						<el-form-item label="零售价">
							<span>{{ props.row.price }}</span>
						</el-form-item>
						<el-form-item label="供货价">
							<span>{{ props.row.costPrice }}</span>
						</el-form-item>
						
						<el-form-item label="排序级别">
							<span>{{ props.row.orderIndex }}</span>
						</el-form-item>
						<el-form-item label="商品简单描述">
							<span>{{ props.row.remark?props.row.remark:'无' }}</span>
						</el-form-item>
						<el-form-item v-if="props.row.authStatus == 2" label="驳回原因">
							<span>{{ props.row.reasonRejection }}</span>
						</el-form-item>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="商品图片">
							<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>

			<el-table-column prop="id" label="商品ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color:#F56C6C;">下架</p>
					<p v-if="scope.row.status==1" style="color:#67C23A;">上架</p>
				</template>
			</el-table-column>
			<el-table-column prop="className" label="所属类别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p>{{scope.row.className}}
						<!-- /{{scope.row.classNameOne}}/{{scope.row.classNameTwo}} -->
					</p>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="goodsType" label="显示位置" align="center" :show-overflow-tooltip="true" width="80">
				<template slot-scope="scope">
					<p v-if="scope.row.goodsType==0"> 云连锁 </p>
					<p v-if="scope.row.goodsType==1"> 商城 </p>
					<p v-if="scope.row.goodsType==2"> 门店 </p>
				</template>
			</el-table-column> -->
			<el-table-column prop="expressType" label="取货方式" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.expressType == 1">到店核销</p>
				</template>
			</el-table-column>
			
			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="salesSum" label="销量" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="price" label="价格" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="marketPrice" label="市场价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="marketPrice" label="赠送积分" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<!-- <p v-if="scope.row.authStatus==0">待审核</p>
					<p v-if="scope.row.authStatus==1">通 过</p>
					<p v-if="scope.row.authStatus==2">驳 回</p> -->
					<p v-if="scope.row.authStatus==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
					<p v-if="scope.row.authStatus==1" style="color:#67C23A;font-weight: bold;">通 过</p>
					<p v-if="scope.row.authStatus==2" style="color:#F56C6C;font-weight: bold;">驳 回</p>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button v-if="scope.row.authStatus==0 && isRecheck" size="small" type="text" @click="editialogVisible(scope.row.id)">
						审核</el-button>
					<el-button  size="small" type="text"  @click="dialogVisibleFun(scope.row)">编辑
					</el-button>
					　　　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<!-- <el-dropdown-item
								@click.native="setUpBuy(scope.row.id,scope.row.goodsName,scope.row.storeId,scope.row.images)">设为拼团商品
							</el-dropdown-item> -->

							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==0 && scope.row.authStatus==1">上架</el-dropdown-item>

							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==1 && scope.row.authStatus==1">下架</el-dropdown-item>
							
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>

							<el-dropdown-item @click.native="auditClick(scope.row)">审核记录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					　　　　
				</template>
				　　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<el-dialog style="float:rigin" title="商品审核" :closeOnClickModal="false" :visible.sync="editDialogVisible"
			width="30%">
			<!-- <div class="app-container" style="text-align: center;display: flex;width: 100%;justify-content: space-between;"> -->
				<!-- <div style="width:48%">
					<el-form size="medium" v-if="auditGoodsInfo">
						<div style="width: 100%;text-align: center;font-size: 22px;padding: 10px;">原信息</div>
						<div>
							<el-form-item label="店铺名称" >
								<el-input type="text" v-model="auditGoodsInfo.storeName" placeholder="请输入" disabled />
							</el-form-item>
							<el-form-item  label="供应商名称">
								<el-input type="text" v-model="auditGoodsInfo.supplierName" placeholder="请输入" disabled />
							</el-form-item>
						</div>
						<div>
							<el-form-item label="商品名称" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfo.goodsName"
									placeholder="请输入商品名称" />
							</el-form-item>
							<el-form-item label="商品编号" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfo.goodsCode"
									placeholder="请输入商品编号" />
							</el-form-item>
						</div>
						
						
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="分类">
								<span>{{ auditGoodsInfo.className ?
								auditGoodsInfo.classNameOne+'/'+auditGoodsInfo.classNameTwo+'/'+auditGoodsInfo.className:'无' }}</span>

							</el-form-item>
							
						</div>
						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="市场价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.marketPrice" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="零售价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.price" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="成本价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.costPrice" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="排序级别" class="redItem" >
								<span>{{auditGoodsInfo.orderIndex}}</span>
							</el-form-item>
							<el-form-item label="销量" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsInfo.salesSum}}</span>
							</el-form-item>
							
							<el-form-item label="库存" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsInfo.stock}}</span>
							</el-form-item>
						</div>

						<div style="display: flex;align-items: center;">
							<el-form-item label="取货方式" :label-width="formLabelWidth">
								<el-select disabled v-model="auditGoodsInfo.expressType" placeholder="请选择取货方式"
									style="width:200px;margin-right:10px;">
									<el-option clearable label="到店核销" :value="1"></el-option>
									
								</el-select>
							</el-form-item>
							
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item :label-width="formLabelWidth" label="是否上架" >
								<el-switch v-model="auditGoodsInfo.status" :active-value="true" :inactive-value="false" disabled>
								</el-switch>
							</el-form-item>
							<el-form-item label-width="300px" label="是否为活动区产品" >
								<el-switch v-model="auditGoodsInfo.isActivity" :active-value="true" :inactive-value="false" disabled>
								</el-switch>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsInfo.isActivity">
								<el-input type="text" disabled size="small" width="50"
								v-model="auditGoodsInfo.reservePoints" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;
						flex-wrap:wrap">
							<el-form-item label="商品图片(1:1)" >
								<br />
								<div style="width: 100%;display: flex;align-items: initial;flex-wrap:wrap">
									<img v-for="(it,index) in fileList" :src="it.url" :key="index" @click="handlePictureCardPreview(it)"
									style="width:144px;height:144px;margin-right:10px;margin-bottom:10px">
								</div>
							</el-form-item>
						</div>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(auditGoodsInfo.detail,1)">点击查看</el-button>
						</el-form-item>
						
					</el-form>
				</div>

				<div style="width:48%">
					<el-form size="medium">
						<div style="width: 100%;text-align: center;font-size: 22px;padding: 10px;">修改后信息</div>
						<div>
							<el-form-item  label="店铺名称">
								<el-input type="text" v-model="auditGoodsInfoTwo.storeName" placeholder="请输入" disabled />
							</el-form-item>
							<el-form-item  label="供应商名称">
								<el-input type="text" v-model="auditGoodsInfoTwo.supplierName" placeholder="请输入" disabled />
							</el-form-item>
						</div>
						<div>
							<el-form-item label="商品名称" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfoTwo.goodsName"
									placeholder="请输入商品名称" />
							</el-form-item>
							<el-form-item label="商品编号" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfoTwo.goodsCode"
									placeholder="请输入商品编号" />
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="分类">
								<span>{{ auditGoodsInfoTwo.className ?
								auditGoodsInfoTwo.classNameOne+'/'+auditGoodsInfoTwo.classNameTwo+'/'+auditGoodsInfoTwo.className:'无' }}</span>

							</el-form-item>
						</div>

						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="市场价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.marketPrice" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="零售价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.price" placeholder="请输入数字" />
							</el-form-item>
						
						</div>

						
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="排序级别" class="redItem" >
								<span>{{auditGoodsInfoTwo.orderIndex}}</span>
							</el-form-item>
							<el-form-item label="销量" class="redItem"  style="margin-left: 30px;">
								<span>{{auditGoodsInfoTwo.salesSum}}</span>
							</el-form-item>
							
							<el-form-item label="库存" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsInfoTwo.stock}}</span>
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;">
							<el-form-item label="取货方式" :label-width="formLabelWidth">
								<el-select disabled v-model="auditGoodsInfoTwo.expressType" placeholder="请选择取货方式"
									style="width:200px;margin-right:10px;">
									<el-option clearable label="到店核销" :value="1"></el-option>
								
								</el-select>
							</el-form-item>
							
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item :label-width="formLabelWidth" label="是否上架" >
								<el-switch v-model="auditGoodsInfoTwo.status" :active-value="true" :inactive-value="false" disabled>
								</el-switch>
							</el-form-item>
							<el-form-item label-width="300px" label="是否为活动区产品" >
								<el-switch v-model="auditGoodsInfoTwo.isActivity" :active-value="true" :inactive-value="false" disabled>
								</el-switch>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsInfoTwo.isActivity">
								<el-input type="text" disabled size="small" width="50"
								v-model="auditGoodsInfoTwo.reservePoints" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;flex-wrap:wrap">
							<el-form-item label="商品图片(1:1)" >
								<br />
								<div style="width: 100%;display: flex;align-items: initial;flex-wrap:wrap">
									<img v-for="(it,index) in fileList1" :src="it.url" :key="index" @click="handlePictureCardPreview(it)"
									style="width:144px;height:144px;margin-right:10px;margin-bottom:10px">
								</div>
								
							</el-form-item>
						</div>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(auditGoodsInfoTwo.detail,1)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</div>
				
			</div> -->
			<div style="text-align: center;">
				<el-button @click="bohui">驳 回</el-button>
				<el-button @click="editStoreInfoCheck(1)" :loading="loadingTG" type="primary">通 过</el-button>

			</div>
		</el-dialog>

		<!-- 审核驳回 -->
		<el-dialog style="float:rigin" title="审核驳回" :closeOnClickModal="false" :visible.sync="editDialogVisible1"
			width="30%">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-form>
					<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
						<el-input style="width: 100%;" v-model="reason" placeholder="请输入驳回原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="editDialogVisible1=false; loading=false">取 消</el-button>
				<el-button @click="editStoreInfoCheck(2)" :loading="loadingBH" type="primary">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div style="max-height:700px;overflow-y:scroll; overflow-x:hidden;">
				<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
				<div v-if="detailType == 2"
					style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
					<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
				</div>
			</div>
			<div style="text-align: center;margin-top:50px">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>

	

		<!-- 新增、编辑商品 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
				

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="商品名称" style="width: 50%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsName" placeholder="请输入商品名称" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="商品编号" style="width: 40%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode" placeholder="请输入商品编号" />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item :label-width="formLabelWidth" label="商品分类">
							<el-select clearable v-model="chainClassId" placeholder="请选择分类"
								style="width:200px;margin:  0px 10px;" @change="classGoods">
								<el-option v-for="item in classssgoods" :key="item.id" :label="item.className" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item  label="可使用卡项" style="width: 400px;">
							<el-select filterable v-model="storeGoodsInfo.cardLists" placeholder="请选择可使用卡项"
							multiple style="width:300px;"
							>
								<el-option v-for="item in KxList"  :key="item.id" :value="item.id" :label="item.cardName">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						
						<el-form-item :label-width="formLabelWidth" label="市场价" >
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.marketPrice" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="零售价格" >
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.price" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="成本价" >
							<el-input type="text"  size="small" width="50"
								v-model="storeGoodsInfo.costPrice" placeholder="请输入数字" />
						</el-form-item>

					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="排序级别">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.orderIndex" placeholder="请输入数字(降序)" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="销量">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.salesSum" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="库存" >
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.stock" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item :label-width="formLabelWidth" label="让利比例">
							<el-select clearable v-model="storeGoodsInfo.yieldProfits" placeholder="请选择让利比例"
								style="width:200px;" @change="changeIntegral">
								<el-option v-for="item in rlList" :key="item.id" :label="item.name" :value="item.proportion">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="取货方式" :label-width="formLabelWidth">
							<el-select clearable v-model="storeGoodsInfo.expressType" placeholder="请选择取货方式"
								style="width:140px;margin-right:10px;">
							
								<el-option clearable label="到店核销" :value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="storeGoodsInfo.storeType==0&&dialogVisibleFunName=='编辑商品'" label="限购数量" :label-width="formLabelWidth">
							<el-input type="number"  size="small" width="80"
								v-model="storeGoodsInfo.limitedPurchaseQuantity" placeholder="请输入限购数量" />
						</el-form-item>
						<el-form-item v-if="storeType==0&&dialogVisibleFunName=='新增商品'" label="限购数量" :label-width="formLabelWidth">
							<el-input type="number"  size="small" width="80"
								v-model="storeGoodsInfo.limitedPurchaseQuantity" placeholder="请输入限购数量" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="是否上架" >
							<el-switch v-model="status" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
					</div>
					<!-- <div v-if="isActivity">
						<el-form-item :label-width="formLabelWidth" label="储备积分" >
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
							v-model="storeGoodsInfo.reservePoints" placeholder="请输入数字" />
						</el-form-item>
					</div> -->
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="商品图片"><br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>

					</div>
					<div v-if="storeType==0&&dialogVisibleFunName=='新增商品'">
						<div style="text-align: start;margin: 10px;">购买须知</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:200px">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.purchaseNotice" ref="myQuillEditor" 
								class="editer" :options="editorOption" style="height:400px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
						<div style="height:300px;"></div>
					</div>
					<div v-if="storeGoodsInfo.storeType==0&&dialogVisibleFunName=='编辑商品'">
						<div style="text-align: start;margin: 10px;">购买须知</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:200px">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.purchaseNotice" ref="myQuillEditor" 
								class="editer" :options="editorOption" style="height:400px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
						<div style="height:300px;"></div>
					</div>
					<div >
						<div style="text-align: start;margin: 10px;">商品详情</div>
						<el-form-item>
							<div id="lpc-quill1" class="quill1" style="width: 100%; height:420px">
								<el-upload class="upload-demo" v-show="false" ref="upload1" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess1" :on-error="uploadError1" />
								<quill-editor v-model="storeGoodsInfo.detail" ref="myQuillEditor1" 
								class="editer" :options="editorOption1" style="height:400px"
									@ready="onEditorReady1($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;margin-top:80px">
				<el-button v-if="dialogVisibleFunName == '新增商品'" type="primary" @click="add">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑商品'" type="primary" @click="sure">编 辑</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>

		<!-- 设为拼团商品 -->
		<!-- <el-dialog :closeOnClickModal="false" style="float:rigin" title="设为拼团商品" :visible.sync="setUpBuyVisible" width="40%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item label="拼团商品名称:" class="redItem">
							<el-input type="text" v-model="buy.goodsName" placeholder="请输入商品名称" />
						</el-form-item>

						<el-form-item label="拼团商品图片(取商品图片第一张):" class="redItem" width="30%">
							<img v-if="buy.goodsImages" :src="buy.goodsImages" @click="dialogVisibleImg=true" width="200px" />
							<div v-else>请先添加商品图片！</div>
						</el-form-item>

					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="拼团商品价格:" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" v-model="buy.price" placeholder="请输入数字" />
						</el-form-item>

						<el-form-item label="拼团数量:" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" v-model="buy.num" placeholder="请输入数字" />
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="setUpBuyVisible = false">取 消</el-button>
				<el-button type="primary" @click="settingBuy">设为拼团商品</el-button>
			</div>
		</el-dialog> -->


		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 审核记录 -->
		<el-dialog style="float:rigin" title="审核记录" :closeOnClickModal="false" :visible.sync="auditFlag"
			width="70%">
			<div style="">
				<el-table :data="auditLogging.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="auditLoading"
					element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
					<el-table-column prop="id" label="ID" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="vertifyBy" label="审核人" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="remark" label="驳回原因" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<span v-if="scope.row.remark">{{ scope.row.remark }}</span>
							<span v-else>暂无</span>
						</template>
					</el-table-column>
					<el-table-column prop="fromDetail" label="审核前" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-button v-if="scope.row.fromDetail" size="small" type="text" @click="preAudit(scope.row.fromDetail)">点击查看</el-button>
							<span v-else>暂无</span>
						</template>
					</el-table-column>
					<el-table-column prop="toDetail" label="审核后" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-button v-if="scope.row.toDetail" size="small" type="text"  @click="afterAudit(scope.row.toDetail)">点击查看</el-button>
							<span v-else>暂无</span>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination style="margin: 20px 0px 20px;" background :current-page="auditLogging.pageNum"
					@current-change="auditPageChange" layout="total, sizes, prev, pager, next, jumper" :total="auditLogging.total"
					@size-change="auditHandleSizeChange">
				</el-pagination>
			</div>
			<div style="text-align: center;">
				<el-button @click="auditFlag=false;loading=false">关闭</el-button>
			</div>
		</el-dialog>


		<!-- 审核前后 -->
		<el-dialog style="float:rigin" :title="auditTitle" :closeOnClickModal="false" :visible.sync="auditDialogVisibleInfo"
			width="50%">
			<div class="app-container" style="text-align: center;display: flex;width: 100%;justify-content: space-between;">
				<div>
					<el-form size="medium" >
						<div style="width: 100%;text-align: center;font-size: 22px;padding: 10px;">原信息</div>
						<div>
							<el-form-item label="店铺名称" style="width: 100%;">
								<el-input type="text" v-model="auditGoodsList.storeName" placeholder="请输入" disabled />
							</el-form-item>
						</div>
						<div>
							<el-form-item label="商品名称" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsList.goodsName"
									placeholder="请输入商品名称" />
							</el-form-item>
							<el-form-item label="商品编号" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsList.goodsCode"
									placeholder="请输入商品编号" />
							</el-form-item>
						</div>
						
						
						<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="分类">
								<span>
									{{classGoods1Id+'/'+classGoods2Id+'/'+classGoods3Id}}
								</span>
							</el-form-item>
							
						</div> -->
						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="市场价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.marketPrice" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="零售价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.price" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="成本价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.costPrice" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="排序级别" class="redItem" >
								<span>{{auditGoodsList.orderIndex}}</span>
							</el-form-item>
							<el-form-item label="销量" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsList.salesSum}}</span>
							</el-form-item>
							
							<el-form-item label="库存" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsList.stock}}</span>
							</el-form-item>
						</div>

						<div style="display: flex;align-items: center;">
							<el-form-item label="取货方式" :label-width="formLabelWidth">
								<el-select disabled v-model="auditGoodsList.expressType" placeholder="请选择取货方式"
									style="width:200px;margin-right:10px;">
									<el-option clearable label="到店核销" :value="1"></el-option>
								
								</el-select>
							</el-form-item>
							
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item :label-width="formLabelWidth" label="是否上架" >
								<el-switch v-model="auditGoodsList.status" :active-value="true" :inactive-value="false" disabled>
								</el-switch>
							</el-form-item>
							<el-form-item label-width="300px" label="是否为活动区产品" >
								<el-switch v-model="auditGoodsList.isActivity" :active-value="true" :inactive-value="false" disabled>
								</el-switch>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsList.isActivity">
								<el-input type="text" disabled size="small" width="50"
								v-model="auditGoodsList.reservePoints" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;
						flex-wrap:wrap">
							<el-form-item label="商品图片(1:1)" >
								<br />
								<div style="width: 100%;display: flex;align-items: initial;flex-wrap:wrap">
									<img v-for="(it,index) in auditGoodsList.images" :src="it" :key="index" @click="handlePictureCardPreview(it)"
									style="width:144px;height:144px;margin-right:10px;margin-bottom:10px">
								</div>
							</el-form-item>
						</div>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(auditGoodsList.detail,1)">点击查看</el-button>
						</el-form-item>
						
					</el-form>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('storeGoods');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function (val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				buy: {
					goodId: null,
					goodsName: null,
					price: null,
					num: null,
					storeId: null,
					status: null,
					goodsImages: ""
				},
				formLabelWidth: '100px',
				setUpBuyVisible: false,
				goodsImages: [],
				fileList: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],

				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,
				KxList:[],
				classGoods1List: [],
				classGoods2List: [],
				yieldProfits:'',
				classGoods3List: [],
				classGoods1Id: "",
				classGoods2Id: "",
				classGoods3Id: "",

				classGoods1Id1: '',
				classGoods2Id1: "",
				classGoods3Id1: "",

				classssgoods:[],
				status: false,
				isActivity: false,
				storeGoodsInfo: { //新增或编辑数据
					classId: "",
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				storeType:'',
				searchInfo: {
					authStatus: '',
					status: '',
				}, //表格查询数据
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
								
							},

						},
					},
					theme: "snow",
				},
				editorOption1: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill1 .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
								
							},
				
						},
					},
					theme: "snow",
				},
				chainClassId:'',
				rlList:[], //积分数据
				stoId: '', //用户ID
				storeNameId: '', //店铺iD
				supplierId: '', // 供应商id 
				selectStoreName: [],
				storeLoading: false,

				isRecheck: false, //是否可以审核
				userID: '', //登录用户ID

				auditGoodsInfo: {}, //商品审核前信息
				auditGoodsInfoTwo: {}, //商品审核后信息
				fileListL: [] , //商品审核前图片
				fileList1: [] , //商品审核后图片
				editDialogVisible1: false,
				reason: '', //驳回信息
				loadingTG: false,
				loadingBH: false,

				auditFlag:false, //审核记录弹窗
				auditLogging:{}, //审核记录
				auditPage: { //审核记录
					pageNum: 1,
					pageSize: 10,
				},
				auditLoading:false,
				auditTitle: '',
				auditDialogVisibleInfo: false,
				auditGoodsList: {}
			};
		},

		methods: {
			// settingBuy() {
			// 	if (!this.buy.goodsImages) {
			// 		this.$message.error("请先设置商品图片");
			// 		return;
			// 	}
			// 	this.$api.GroupbuyGoodsInfo(this.buy).then((res) => {
			// 		if (res.state == 'success') {
			// 			this.setUpBuyVisible = false;
			// 			this.$message({
			// 				message: res.message,
			// 				type: 'success'
			// 			});
			// 		} else {
			// 			this.$message.error(res.message);
			// 		}
			// 	})

			// },
			preAudit(e){// 审核前
				// console.log('审核前---',JSON.parse(e))
				let data =JSON.parse(e);
				this.auditTitle = '审核前'
				// if(data){
					this.auditDialogVisibleInfo = true;
					this.auditGoodsList = data
					if(data.images){
						this.auditGoodsList.images = data.images.split(',')
					}
				// }else{
				// 	this.$message.error('新增商品审核前信息是空白的哦！');
				// }
			
				
			},
			afterAudit(e){// 审核后
				// console.log('审核后---',JSON.parse(e))
				let data =JSON.parse(e);
				this.auditTitle = '审核后'
				this.auditDialogVisibleInfo = true;
				this.auditGoodsList = data
				// this.auditGoodsList.images = data.images.split(',')
				if(data.images){
					this.auditGoodsList.images = data.images.split(',')
				}
				// console.log(this.auditGoodsList)
			},
			auditClick(item){
				// console.log('商品审核记录--',item)
				this.auditPage.goodsId = item.id
				this.auditPage.pageNum = 1;
				this.auditPage.pageSize = 10;
				this.getAuditLogging()
				this.auditFlag = true;
			},
			auditPageChange(data) { //审核记录
				this.auditPage.pageNum = data
				this.getAuditLogging()
			},
			auditHandleSizeChange(val) { //审核记录
				this.auditPage.pageSize = val
				this.getAuditLogging()
			},
			classGoods(e){
				this.storeGoodsInfo.chainClassId=e
			},
			getAuditLogging(){ //查询审核记录
				this.auditLoading = true
				// console.log('审核记录---', this.auditPage)
				this.$api.findshenhgoods(this.auditPage).then((res) => { //商品列表
					// console.log(res);
					if (res.state == 'success') {
						this.auditLogging = res.data
						this.auditLoading = false
					}
				})
			},
			remoteMethod(query) {
				if (query.length >= 2) {
					this.storeLoading = true;
					setTimeout(() => {
						let data = {
							storeName: query,
						}
						this.$api.getStoreNameList(data).then((res) => { //店铺管理
							if (res.state == 'success') {
								this.selectStoreName = res.data;
							} else {
								this.$message.error(res.message);
							}
						})
						this.storeLoading = false;
					}, 200);
					} else {
						this.selectStoreName = [];
					}
			},
			searchStore(){
				let data = {
					storeName: '',
				}
				this.$api.getStoreNameList(data).then((res) => { //店铺管理
					if (res.state == 'success') {
						this.selectStoreName = res.data;
						// console.log('店铺管理---', res.data)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getStoreName(e) {
				// console.log(e);
				this.supplierId = ''
				// this.storeNameId = e
				// console.log(this.selectStoreName);
				// console.log(e);
				let obj = {};
				obj = this.selectStoreName.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.storeName = obj.storeName;
				this.storeGoodsInfo.storeId = e;
				this.accountList = []
				if (e) {
					this.$api.supplierNameList({ 
						storeId: e
					}).then(res => {
						// res = JSON.parse(this.$decrypt(res.data))
						if (res.state == 'success') {
							this.accountList = res.data;
						}
					})
				}

			},
			getSupplier(e){ //选择供应商
				// console.log('选择店铺--', e)
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.supplierName = obj.supplierName;
				this.storeGoodsInfo.supplierId = e;
			},
			setUpBuy(goodId, goodsName, storeId, image) {
				this.buy = {};
				this.setUpBuyVisible = true;
				this.buy.goodId = goodId;
				this.buy.goodsName = goodsName;
				this.buy.storeId = storeId;
				this.buy.price = 1000.00;
				this.buy.num = 1;
				this.buy.goodsImages = image.split(",")[0];
				this.dialogImageUrl = this.buy.goodsImages;
			},
			onSuccess(response, file, fileList) {
				this.goodsImages.push(response.message);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			getStoreAndUser(e) {
				// console.log(e);
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.username = obj.username;
				this.storeGoodsInfo.storeName = obj.storeName;
				this.storeGoodsInfo.userId = obj.userId;
			},
			
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			storeGoodsHitTheShelfOrSoldOut(id) {
				// this.$api.storeGoodsIsPutaway(id).then((res) => {
				this.$api.storeGoodsHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreGoodsList()
			},
			//商品审核
			editStoreInfoCheck(authStatus) {
				if (authStatus == 2) {
					this.loadingBH = true;
					//驳回
					var data = {
						id: this.ids,
						authStatus: 2,
						// status
						reasonRejection: this.reason
					}
				} else {
					this.loadingTG = true;
					//通过审核
					var data = {
						id: this.ids,
						authStatus: 1
					}
				}
				// this.$api.productReview(data).then((res) => {
				this.$api.storeGoodsReview(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.editDialogVisible1 = false
						this.reason = ''
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
					this.loadingTG = false;
					this.loadingBH = false;
				})

			},
			bohui() {
				this.editDialogVisible1 = true
			},
			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			getClassName(id){
				let val = "";
				this.$api.findByGoodsClassId(id).then((res) => { //根据id查询商品分类
					if (res.state == 'success') {
						// console.log('第二及---', res.data)
						val = res.data.className
					}
				})
				return val;
			},
			//商品审核弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.auditGoodsInfo = {};
				this.fileList = [];
				this.classGoods1Id = ""
				this.classGoods2Id = ""
				this.classGoods3Id = ""
				this.ids=id
				this.auditGoodsInfoTwo = {};
				this.classGoods1Id1 = ""
				this.classGoods2Id1 = ""
				this.classGoods3Id1 = ""
				this.fileList1 = [];

				this.$api.findshdetail(id).then((res) => {
					if (res.state == 'success') {
						// this.auditGoodsInfo = res.data
						// console.log('回显数据---', res.data)
						
						
						let res1=JSON.parse(res.data.fromDetail)
						let res2=JSON.parse(res.data.toDetail)

						// console.log('回显数据前---', res1)
						// console.log('回显数据后---', res2)
						
						if(res1!=null){
							this.auditGoodsInfo = res1

							// let str1 ={}
							// str1 = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
							// 	return item.id === res1.classIdOne; //筛选出匹配数据
							// });
							// this.classGoods1Id = str1.className
							// this.$api.findByGoodsClassId(res1.classIdTwo).then((res) => { //根据id查询商品分类
							// 	if (res.state == 'success') {
							// 		this.classGoods2Id = res.data.className
							// 	}
							// })
							// this.$api.findByGoodsClassId(res1.classId).then((res) => { //根据id查询商品分类
							// 	if (res.state == 'success') {
							// 		// console.log('第二及---', res.data)
							// 		this.classGoods3Id = res.data.className
							// 	}
							// })

							let imagesArray = res1.images.split(",");
							
							for (let i = 0; i < imagesArray.length; i++) {
								this.fileList.push({
									name: imagesArray[i],
									url: imagesArray[i]
								})
							}
						}
						this.auditGoodsInfoTwo = res2
						if(res2.intermediatorUserId != 0 && res2.intermediatorUserId != null){
							this.auditGoodsInfoTwo.joint = res2.intermediatorUserId + '~' + res2.username + '~' +res2.phone 
						}

						// let str11 ={}
						// str11 = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
						// 	return item.id === res1.classIdOne; //筛选出匹配数据
						// });
						// this.classGoods1Id1 = str11.className
						// this.$api.findByGoodsClassId(res1.classIdTwo).then((res) => { //根据id查询商品分类
						// 	if (res.state == 'success') {
						// 		this.classGoods2Id1 = res.data.className
						// 	}
						// })
						// this.$api.findByGoodsClassId(res1.classId).then((res) => { //根据id查询商品分类
						// 	if (res.state == 'success') {
						// 		// console.log('第二及---', res.data)
						// 		this.classGoods3Id1 = res.data.className
						// 	}
						// })
						// this.classGoods1Id1 = res2.c1
						// this.classGoods2Id1 = res2.c2
						// this.classGoods3Id1 = res2.c3
					
						let imagesArray1 = res2.images.split(",");
						for (let i = 0; i < imagesArray1.length; i++) {
							this.fileList1.push({
								name: imagesArray1[i],
								url: imagesArray1[i]
							})
						}
					}
				})
				this.storeGoodsId = id
				this.editDialogVisible = true;
			},
			//选中一级分类
			classGoods1(e) {
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.classGoods3List = {};
				if (e) {
					// console.log(e)
					let obj = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
						return item.id === e; //筛选出匹配数据
					});
					this.storeGoodsInfo.classNameOne = obj.className;
					this.$api.goodsClassfindByPid(e).then((res) => { //商品二级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				// console.log(e)
				this.classGoods3Id = "";
				this.classGoods3List = {};
				if (e) {
					let obj = this.classGoods2List.find((item) => { //这里的userList就是上面遍历的数据源
						return item.id === e; //筛选出匹配数据
					});
					this.storeGoodsInfo.classNameTwo = obj.className;

					this.$api.goodsClassfindByPid(e).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods3List = res.data;
						}
					})
				}
			},
			//选中三级分类
			classGoods3(e) {
				// console.log(e)
				let obj = {};
				obj = this.classGoods3List.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.className = obj.className;
				this.storeGoodsInfo.classId = obj.id;
				this.storeGoodsInfo.classIdOne = this.classGoods1Id;
				this.storeGoodsInfo.classIdTwo = this.classGoods2Id;
			},
			changeIntegral(e){
				// console.log('积分选择--',e)
			},
			// 店铺编辑弹窗
			dialogVisibleFun(item) {
				if(item){
					this.fllist(item.id)
				}else{
					this.fllist()
				}
				
				this.storeInfo = {}
				this.dialogVisibleFunName = "新增商品"
				this.dialogVisible = true;
				
				this.storeGoodsInfo = {
					yieldProfits:this.yieldProfits
				};
			
		
				this.goodsImages = [];
				this.fileList = [];
			
				this.chainClassId = "";
			

				if(this.stoId != 0){ //该用户有店铺，根据id查供应商
					this.$api.supplierNameList({ 
						storeId: this.stoId
					}).then(res => {
						// res = JSON.parse(this.$decrypt(res.data))
						if (res.state == 'success') {
							this.accountList = res.data;
						}
					})
				}else{
					this.searchStore(); //查询所有店铺
				}

				if (item.id) {
					this.fllist(item.id)
					this.dialogVisibleFunName = "编辑商品"
					this.storeGoodsId = item.id

					this.$api.findGoodsById(this.storeGoodsId).then((res) => {
						console.log(res,132456);

					// this.$api.findGoodsById(this.storeGoodsId).then((res) => {
					this.$api.storeGoodsFindById(this.storeGoodsId).then((res) => {

						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							
							this.status = this.storeGoodsInfo.status;
					        this.isActivity = this.storeGoodsInfo.isActivity;
							// this.searchStore();
							this.chainClassId = res.data.chainClassId
							let imagesArray = res.data.images.split(",");
							this.goodsImages = imagesArray;
							for (let i = 0; i < imagesArray.length; i++) {
								if (imagesArray[i]) {
									this.fileList.push({
										name: imagesArray[i],
										url: imagesArray[i]
									})
								}
							}
						}
					})
				})
				}
				
			},
			//添加商品
			add() {

			
				if(this.stoId != 0){
					this.storeGoodsInfo.storeId = this.stoId
				}
				// this.storeGoodsInfo.classNameAll = classNameAll
				this.storeGoodsInfo.status = this.status;
				this.storeGoodsInfo.isActivity = this.isActivity;
				this.storeGoodsInfo.images = this.goodsImages.toString();
				this.storeGoodsInfo.goodsType = 0;
				// console.log('添加商品数据---',this.storeGoodsInfo)

				// this.$api.addXiaGoods(this.storeGoodsInfo).then((res) => {
				this.$api.addStoreGoods(this.storeGoodsInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreGoodsList();
						this.dialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//编辑商品
			sure() {
				
				if(this.stoId != 0){
					this.storeGoodsInfo.storeId = this.stoId
				}

				this.storeGoodsInfo.status = this.status;
				this.storeGoodsInfo.isActivity = this.isActivity;
				
				this.storeGoodsInfo.images = this.goodsImages.toString();

				console.log('编辑商品数据---',this.storeGoodsInfo)
				this.$api.updateXiaGoods(this.storeGoodsInfo).then((res) => {

				this.storeGoodsInfo.goodsType = 0;
				// console.log('编辑商品数据---',this.storeGoodsInfo)
				// this.$api.updateXiaGoods(this.storeGoodsInfo).then((res) => {
				this.$api.editStoreGoods(this.storeGoodsInfo).then((res) => {

					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
				})

			})
			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// this.$api.deleteByIdssgoods(row.id).then((res) => {
					this.$api.delStoreGoods(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.loading = true
				/* let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					storeName: this.searchInfo.storeName,
					goodsName: this.searchInfo.goodsName,
					status: this.searchInfo.status,
					authStatus: this.searchInfo.authStatus,
					goodsCode: this.searchInfo.goodsName
				} */
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;
				// this.searchInfo.storeId = 53;
				// this.$api.ssGoodsList(this.searchInfo).then((res) => { //商品列表
				this.$api.getStoreGoodsList(this.searchInfo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.goodsList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			//上传店铺logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.message
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.message
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			upScuccess1(res, file) {
				const quill1 = this.$refs.myQuillEditor1.quill;
			
				if (res.state == "success" && res.data !== null) {
					const length = quill1.getSelection().index; // 获取光标所在位置
					quill1.insertEmbed(length, "image", res.message); // 插入图片
					quill1.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			uploadError1() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			onEditorReady1(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			getIsRecheck(id){
				// 查询可以审核商品的ID
				this.$api.byKey({key:'SYS_GOODS_CHECK'}).then(res=>{ 
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						// console.log(res);
						let arr = (res.data.settingValue.split(','))
						this.isRecheck = arr.some(item => {
							return item == id
						})
						// console.log('登录人ID---',id)
						// console.log('数据---',arr)
						// console.log('是否可审核---',this.isRecheck)
					}
				})
			},
			fllist(id){
				this.$api.findChainGoodsClassList(id?'/'+id:'').then((res) => { //商品一级分类
				// this.$api.findClassList().then((res) => { //商品一级分类
					if (res.state == 'success') {
						this.classssgoods = res.data;
					}
				})
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						
						// supplierId(有值就是供应商)
						this.yieldProfits=res.data.yieldProfits
						this.storeType=res.data.storeType
						this.stoId = res.data.storeId; // storeId：0(平台)  
						
						this.userID = res.data.id
						// this.supplierId = res.data.supplierId;
						this.getIsRecheck(res.data.id)
					}
				})
				
			}
		},
		created() {
			this.getStoreGoodsList();
			
			this.$api.finderpCard({}).then(res=>{
				console.log(res);
				this.KxList=res.data.list
			})
			
			this.$api.storeProportionType().then(res=>{
					this.rlList=res.data
			})

			// this.$api.getUserInfo(this.$encrypt({})).then(res => {
			// 	res.data = JSON.parse(this.$decrypt(res.data)).data
			// 	if (res.state == 'success') {
			// 		// console.log('用户信息--', res.data)
			// 		this.stoId = res.data.storeId
			// 	}
			// })


			this.logInUserInfo();
		}

	};
</script>

<style scoped lang="less">
	/* 富文本 */
	/deep/ .ql-toolbar {
		width: 100%;
		text-align: left;
	}
	/deep/.ql-editor {
		height: 400px;
	}

	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}
</style>